import React from "react";

const Pdf = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <defs>
      <linearGradient id="shadow" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#000000" stopOpacity=".10" />
        <stop offset="100%" stopColor="#000000" stopOpacity=".02" />
      </linearGradient>
      <filter id="ds" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="0" dy="2" stdDeviation="2" floodOpacity=".15" />
      </filter>
    </defs>
    <g filter="url(#ds)">
      <path
        d="M14 4H40L50 14V56C50 58.2 48.2 60 46 60H14C11.8 60 10 58.2 10 56V8C10 5.8 11.8 4 14 4Z"
        fill="white"
      />
      <path d="M40 4V14H50" fill="#F4F4F4" />
      <path d="M40 4L50 14H40Z" fill="#ECECEC" />
    </g>
    <rect x="10" y="4" width="8" height="56" rx="2" fill="#D93025" />
    <rect x="22" y="18" width="20" height="2.5" rx="1.25" fill="#E3E6EB" />
    <rect x="22" y="24" width="18" height="2.5" rx="1.25" fill="#E3E6EB" />
    <rect x="22" y="30" width="16" height="2.5" rx="1.25" fill="#E3E6EB" />
    <rect x="14" y="40" width="36" height="14" rx="7" fill="#D93025" />
    <text
      x="32"
      y="50"
      textAnchor="middle"
      fontFamily="Segoe UI, Arial, sans-serif"
      fontSize="10"
      fontWeight="700"
      fill="white"
    >
      PDF
    </text>
  </svg>
);

export default Pdf;